module.exports = __webpack_public_path__ + "static/img/solution_banner1.afb33ea8.png";